import { createContext } from "react";

/**
 * The already-resolved workspace id, shared with the views' subtree. It is filled
 * in by WorkspaceIdProvider (mounted by ViewWrapper) and read with useWorkspaceId.
 */
export const WorkspaceIdContext = createContext<string | undefined>(undefined);
